import React, { useMemo } from "react";
import { useForm } from "react-hook-form";
import styles from "./InstructionField.module.scss";
import FileUploadButton from "components/shared/fileUploadButton/FileUploadButton";
import InputTextArea from "components/shared/textArea/InputTextArea";
import { handleFile } from "utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { setDroppedItems, setUpdateDroppedItems } from "@redux/slices/formSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import { setPublish } from "@redux/slices/globalSlice";

const InstructionsField = () => {
  const { control } = useForm();
  const dispatch = useDispatch();
  const { droppedItems, selectedData } = useSelector((state) => state.form);

  // Handle text input change
  const handleChange = (e) => {
    const updatedData = { value: e.target.value };
    dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData }));
    dispatch(setPublish(true));
  };

  // Handle file input change
  const handleFileChange = (file, setIsLoading) => {
    handleFile(file, droppedItems, selectedData, dispatch, setDroppedItems, setIsLoading);;
    dispatch(setPublish(true));
  };

  const handleImageDelete = (src, selectedItem) => {
    const updatedMedia = selectedItem?.data?.media.filter(
      (media) => media.path !== src
    );

    const updatedData = { media: updatedMedia };

    dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData }));
    dispatch(setPublish(true));
  };

  const handleOpenImage = (src) => {
    window.open(src, "__blank");
  };

  const currentItem = useMemo(
    () => droppedItems.find((item) => item.id === selectedData.id),
    [droppedItems, selectedData]
  );

  return (
    <div className={styles?.instructionsForm}>
      <div className={styles?.formField}>
        <InputTextArea
          control={control}
          type="textarea"
          name="Instruction"
          placeholder="Instruction"
          onChange={handleChange}
          className={styles.textArea}
        />
      </div>
      <div className={styles?.formField}>
        {currentItem?.data?.media?.length ? (
          <div className={styles.imageContainer}>
            {currentItem?.data?.media?.map((src, index) => (
              <div
                className={styles.imageWrapper}
                onClick={() => handleOpenImage(src.path)}
              >
                <img src={src.path} alt="" />
                <div
                  className={styles.cancelIcon}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    handleImageDelete(src.path, currentItem);
                  }}
                >
                  <DeleteIcon sx={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <FileUploadButton
            name="mediaFile"
            control={control}
            onFileChange={handleFileChange}
          />
        )}
      </div>
    </div>
  );
};

export default InstructionsField;
